// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let ChangePasswordMessage = function (fieldSet)
{
    this.Code = Message.CODE_PFIX_CHANGE_PASSWORD_REQUEST;
    PFixMessage.call(this, fieldSet);
}
ChangePasswordMessage.prototype = Object.create(PFixMessage.prototype);


ChangePasswordMessage.prototype.getUserId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_USER_ID);
}
ChangePasswordMessage.prototype.setUserId = function (userId)
{
    this.setFieldValue(FieldsFactory.FIELD_USER_ID, userId);
}

ChangePasswordMessage.prototype.getPassword = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_PASSWORD);
}
ChangePasswordMessage.prototype.setPassword = function (password)
{
    this.setFieldValue(FieldsFactory.FIELD_PASSWORD, password);
}

ChangePasswordMessage.prototype.getNewPassword = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_NEWPASSWORD);
}
ChangePasswordMessage.prototype.setNewPassword = function (password)
{
    this.setFieldValue(FieldsFactory.FIELD_NEWPASSWORD, password);
}

ChangePasswordMessage.prototype.setVerificationPassword = function (verificationPassword)
{
    this.setFieldValue(FieldsFactory.FIELD_VERIFICATION_PASSWORD, verificationPassword);
}

ChangePasswordMessage.prototype.setAccessToken = function (accessToken)
{
    this.setFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN, accessToken);
}